/* ============================================================
   CurioBox — Roastery product card
   Variant switching, variant photos, and a hover photo loop.
   Pairs with snippets/product-card-1 + roastery-card.css
   ============================================================ */
(function () {
  'use strict';

  var WIDTHS = [165, 360, 535, 750, 940, 1100];
  var STEP_MS = 900;

  function money(cents, format) {
    var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (format && format.indexOf('{{amount}}') !== -1) return format.replace('{{amount}}', value);
    return 'AED ' + value;
  }

  /* Shopify serves every size from one file via ?width=. Replace that single
     parameter rather than appending, or a second pass yields width=1100&width=360. */
  function sized(src, w) {
    if (!src) return '';
    var hash = '', i = src.indexOf('#');
    if (i > -1) { hash = src.slice(i); src = src.slice(0, i); }
    var bits = src.split('?');
    var query = (bits[1] || '').split('&').filter(function (part) {
      return part && part.indexOf('width=') !== 0 && part.indexOf('height=') !== 0 && part.indexOf('crop=') !== 0;
    });
    query.push('width=' + w);
    return bits[0] + '?' + query.join('&') + hash;
  }

  function readJson(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function media(query) {
    try { return window.matchMedia && window.matchMedia(query).matches; } catch (e) { return false; }
  }

  function init(root) {
    if (root.dataset.rcReady === '1') return;
    root.dataset.rcReady = '1';

    /* ---------------- the photo ---------------- */
    var mainImg = root.querySelector('.rc-card__img:not(.rc-card__img--alt)');
    var baseSrc = root.dataset.rcBaseImage || (mainImg ? mainImg.getAttribute('src') : '');
    var baseAlt = root.dataset.rcBaseAlt || (mainImg ? mainImg.getAttribute('alt') : '');

    var images = {};
    (readJson(root, '[data-rc-variant-images]') || []).forEach(function (row) {
      if (row && row.src) images[row.id] = row;
    });
    var gallery = (readJson(root, '[data-rc-gallery]') || []).filter(Boolean);

    var anchorSrc = '';           /* the photo the card belongs on when idle */
    var anchorAlt = baseAlt;
    var shownSrc = mainImg ? mainImg.getAttribute('src') : '';

    function showSrc(src, alt) {
      if (!mainImg || !src) return;
      if (shownSrc && sized(shownSrc, 1100) === sized(src, 1100)) return;
      shownSrc = src;

      /* Dim rather than blank: a photo that never arrives still leaves a card
         you can read. Whichever of load/error/timeout comes first clears it. */
      mainImg.classList.add('rc-card__img--swap');
      var settle = function () { mainImg.classList.remove('rc-card__img--swap'); };
      mainImg.addEventListener('load', settle, { once: true });
      mainImg.addEventListener('error', settle, { once: true });
      setTimeout(settle, 500);

      mainImg.setAttribute('srcset', WIDTHS.map(function (w) {
        return sized(src, w) + ' ' + w + 'w';
      }).join(', '));
      mainImg.setAttribute('src', sized(src, 1100));
      if (alt) mainImg.setAttribute('alt', alt);
    }

    /* ---------------- variants ---------------- */
    var variants = readJson(root, '[data-rc-variants]');
    if (!Array.isArray(variants) || !variants.length) variants = null;

    var chips = Array.prototype.slice.call(root.querySelectorAll('.rc-chip'));
    var format = root.dataset.rcMoneyFormat || '';
    var priceEl = root.querySelector('[data-rc-price]');
    var input = root.querySelector('[data-rc-variant-input]');
    var button = root.querySelector('[data-rc-add]');
    var label = root.querySelector('[data-rc-add-label]');
    var soldOutText = root.dataset.rcSoldOut || 'Sold out';
    var addText = root.dataset.rcAdd || 'Add to cart';

    function selection() {
      var picked = [];
      root.querySelectorAll('.rc-opt').forEach(function (group) {
        var on = group.querySelector('.rc-chip[aria-pressed="true"]');
        picked[Number(group.dataset.rcPosition) - 1] = on ? on.dataset.rcValue : null;
      });
      return picked;
    }

    function match(picked) {
      if (!variants) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < picked.length; j++) {
          if (picked[j] !== null && v.options[j] !== picked[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* grey out values that cannot be reached from the current selection */
    function markAvailability(picked) {
      root.querySelectorAll('.rc-opt').forEach(function (group) {
        var pos = Number(group.dataset.rcPosition) - 1;
        group.querySelectorAll('.rc-chip').forEach(function (chip) {
          var trial = picked.slice();
          trial[pos] = chip.dataset.rcValue;
          var v = match(trial);
          chip.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    /* Which option axis is the colourway, if any. The loop prefers to walk
       along it, so hovering shows the same machine in its other finishes
       rather than a jumble of sizes. */
    var colourPos = 0;
    root.querySelectorAll('.rc-opt').forEach(function (group) {
      var name = (group.getAttribute('aria-label') || '').toLowerCase();
      if (!colourPos && /colou?r|shade|finish|style/.test(name)) colourPos = Number(group.dataset.rcPosition);
    });

    var firstPaint = true;
    function pathOf(u) { return String(u || '').split('?')[0]; }

    /* Settle the card on the chosen variant's own photo, falling back to the
       product photo when that variant has none of its own. */
    function paintImage(v) {
      if (!mainImg) return;
      var row = v ? images[v.id] : null;
      anchorSrc = row && row.src ? row.src : baseSrc;
      anchorAlt = row && row.alt ? row.alt : baseAlt;
      if (!anchorSrc) return;

      /* On load Liquid has already rendered the right photo. Record it and
         leave the markup alone rather than fetching the same file again. */
      if (firstPaint) {
        firstPaint = false;
        if (pathOf(mainImg.getAttribute('src')) === pathOf(anchorSrc)) {
          shownSrc = anchorSrc;
          return;
        }
      }
      showSrc(anchorSrc, anchorAlt);
    }

    function apply() {
      var picked = selection();
      var v = match(picked);
      markAvailability(picked);
      if (!v) return;

      if (input) input.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, format);

      var reduced = v.compare_at_price && v.compare_at_price > v.price;
      var cmp = root.querySelector('[data-rc-compare]');
      if (cmp) {
        cmp.hidden = !reduced;
        if (reduced) cmp.textContent = money(v.compare_at_price, format);
      }
      var badge = root.querySelector('[data-rc-sale]');
      if (badge) {
        badge.hidden = !reduced;
        if (reduced && badge.dataset.rcSaleMode === 'show_percentage') {
          badge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
        }
      }

      if (button) {
        button.disabled = !v.available;
        if (label) label.textContent = v.available ? addText : soldOutText;
      }

      /* Quotation cards carry no add-to-cart form; the pill holds the chosen
         variant instead, so the quote follows what is on screen. */
      var pill = root.querySelector('[data-cbq-open]');
      if (pill) pill.setAttribute('data-cbq-variant', v.id);

      stopLoop(false);
      paintImage(v);
      clearTimeout(resume);
      if (hovering) resume = setTimeout(startLoop, 1400);
    }

    if (variants && chips.length) {
      root.addEventListener('click', function (e) {
        var chip = e.target.closest('.rc-chip');
        if (!chip || !root.contains(chip)) return;
        e.preventDefault();
        chip.parentNode.querySelectorAll('.rc-chip').forEach(function (c) {
          c.setAttribute('aria-pressed', String(c === chip));
        });
        apply();
      });
      apply();
    } else {
      paintImage(null);
    }

    /* ---------------- the hover loop ---------------- */
    /* What to walk through: the other colourways of the machine on screen,
       else every distinct variant photo, else the product's own gallery. */
    function sequence() {
      var seq = [], seen = {};
      if (variants) {
        var picked = selection();
        variants.forEach(function (v) {
          if (colourPos) {
            for (var j = 0; j < picked.length; j++) {
              if (j === colourPos - 1) continue;
              if (picked[j] !== null && v.options[j] !== picked[j]) return;
            }
          }
          var row = images[v.id];
          if (row && row.src && !seen[row.src]) { seen[row.src] = 1; seq.push(row.src); }
        });
      }
      if (seq.length > 1) return seq;
      return gallery.length > 1 ? gallery.slice(0, 6) : [];
    }

    var timer = null, warmed = false, hovering = false, resume = null;
    function stopLoop(restore) {
      if (timer) { clearInterval(timer); timer = null; }
      root.removeAttribute('data-rc-cycle');
      if (restore && anchorSrc) showSrc(anchorSrc, anchorAlt);
    }

    function startLoop() {
      if (timer || !mainImg) return;
      var seq = sequence();
      if (seq.length < 2) return;

      if (!warmed) {                       /* fetch them once so the loop is smooth */
        warmed = true;
        seq.forEach(function (s) { var pre = new Image(); pre.src = sized(s, 535); });
      }

      /* Take over from the theme's plain hover flip while we are running. */
      root.setAttribute('data-rc-cycle', '1');

      var i = 0;
      seq.forEach(function (s, n) { if (pathOf(s) === pathOf(anchorSrc)) i = n; });

      timer = setInterval(function () {
        if (!document.contains(root)) { stopLoop(false); return; }
        i = (i + 1) % seq.length;
        showSrc(seq[i], anchorAlt);
      }, STEP_MS);
    }

    /* Only where hovering is a real gesture, and never against the wishes of
       someone who has asked for less motion. */
    if (media('(hover: hover)') && !media('(prefers-reduced-motion: reduce)')) {
      root.addEventListener('mouseenter', function () { hovering = true; startLoop(); });
      root.addEventListener('mouseleave', function () {
        hovering = false;
        clearTimeout(resume);
        stopLoop(true);
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-rc-card]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* collection filtering and infinite scroll replace the grid, so re-scan */
  new MutationObserver(function (records) {
    records.forEach(function (r) {
      r.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('[data-rc-card]')) init(n);
        else boot(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();